<template>
  <div class="f f-as">
    <donut-page-title :title="$i18n.t('shoutouts.feature') + ' settings'" :subtitle="subtitle" />
    <div class="f fc-s0">
      <a class="button inv m-r" :href="goToButton.href">Go to {{ goToButton.text }}</a>
      <button :class="primaryButton.class" @click="primaryButton.onClick">{{ primaryButton.text }}</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed, inject, watch } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';

  const $i18n = inject('$i18n');
  const { state, commit, dispatch } = useStore();

  const props = defineProps({
    program: { type: Object, required: true },
    tags: { type: Array, required: true },
  });
  const program = ref(props.program);

  watch(() => state.shoutoutsProgram.program, (newVal) => {
    if (newVal !== program.value) {
      program.value = newVal;
    }
  });

  const subtitle = computed(() => {
    if (program.value.state === 'active') {
      return `Amplify great work and celebrate wins with ${$i18n.t('shoutouts.feature')}: peer-to-peer recognition `
        + `and ${$i18n.t('shoutouts.reward', { count: 2 })} in any channel where you use Donut. Customize it for your team.`;
    }
      return `Your ${$i18n.t('shoutouts.feature')} program is currently inactive! Click `
          + `"Activate ${$i18n.t('shoutouts.feature')}" so teammates can start recognizing eachother in Slack.`;
  });

  // Buttons
  const primaryButton = computed(() => {
    const buttonClasses = ['button'];
    if (state.formSubmitted) buttonClasses.push('loading');
    const button = { class: buttonClasses };
    if (program.value.state === 'active') {
      button.text = `Announce ${$i18n.t('shoutouts.feature')}`;
      button.onClick = () => {
        commit('updateModal', {
          visible: true,
          subcomponent: 'shoutouts-programs-modals-launch-announcement',
          size: 'xl',
          data: { tags: props.tags },
        });
      };
    } else {
      button.text = `Activate ${$i18n.t('shoutouts.feature')}`;
      button.onClick = () => { dispatch('shoutoutsProgram/activateProgram', { tags: props.tags }); };
    }
    return button;
  });

  const goToButton = { text: capitalize($i18n.t('shoutouts.reward', { count: 2 })), href: '/rewards/settings' };
</script>
